import { SearchHit } from "../../../common/decorators/search-hit.decorator"

export class TopCompany {
    id: string
    @SearchHit()
    name: string
    count: number
    percent: number
}